import type { ReactNode, SVGProps } from 'react'

/**
 * The few line icons the public pages need that the console kit does not ship
 * (mail, lock, key, card, check-circle, eye). Same 24-unit grid, 1.75 stroke
 * and `currentColor` as `shared/console/icons.tsx`, so they sit beside kit
 * icons without a seam. Kept here because the kit is not ours to edit.
 */
export interface PublicIconProps extends Omit<SVGProps<SVGSVGElement>, 'children'> {
  size?: number
}

function make(name: string, body: ReactNode) {
  function Icon({ size = 16, strokeWidth = 1.75, ...rest }: PublicIconProps) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
        {...rest}
      >
        {body}
      </svg>
    )
  }
  Icon.displayName = name
  return Icon
}

export const IconMail = make(
  'IconMail',
  <>
    <rect width="20" height="16" x="2" y="4" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </>,
)
export const IconLock = make(
  'IconLock',
  <>
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </>,
)
export const IconKey = make(
  'IconKey',
  <>
    <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4" />
    <path d="m21 2-9.6 9.6" />
    <circle cx="7.5" cy="15.5" r="5.5" />
  </>,
)
export const IconCard = make(
  'IconCard',
  <>
    <rect width="20" height="14" x="2" y="5" rx="2" />
    <line x1="2" x2="22" y1="10" y2="10" />
  </>,
)
export const IconCheckCircle = make(
  'IconCheckCircle',
  <>
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </>,
)
export const IconCircle = make('IconCircle', <circle cx="12" cy="12" r="10" />)
